import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { UserRequiresPhoneVerificationCollection } from './user-requires-phone-verification.types';

export function userRequiresPhoneVerificationBackend(): Backend<UserRequiresPhoneVerificationCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'phone-verification/shouldPhoneVerify.php',
      isGaf: true,
      params: {},
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
